/**
 * Labstep
 *
 * @module prosemirror/components/Toolbar/Left
 * @desc Button to display a list of actions on the left
 */

import { Dropdown } from 'labstep-web/core/Dropdown';
import { Experiment } from 'labstep-web/models/experiment.model';
import { Protocol } from 'labstep-web/models/protocol.model';
import { ToolbarButton } from 'labstep-web/prosemirror/components/Toolbar/Button';
import { CodeToolbar } from 'labstep-web/prosemirror/components/Toolbar/Code';
import { ExperimentToolbar as ToolbarExperiment } from 'labstep-web/prosemirror/components/Toolbar/Experiment';
import { FileToolbar as ToolbarFile } from 'labstep-web/prosemirror/components/Toolbar/File';
import { LinkToolbar as ToolbarLink } from 'labstep-web/prosemirror/components/Toolbar/Link';
import { MetadataToolbar as ToolbarMetadata } from 'labstep-web/prosemirror/components/Toolbar/Metadata';
import { StepToolbarContainer as ToolbarProtocolStep } from 'labstep-web/prosemirror/components/Toolbar/ProtocolStep';
import { ProtocolTableToolbar as ToolbarProtocolTable } from 'labstep-web/prosemirror/components/Toolbar/ProtocolTable';
import { TimerToolbar as ToolbarProtocolTimer } from 'labstep-web/prosemirror/components/Toolbar/ProtocolTimer';
import { ValueToolbar as ToolbarProtocolValue } from 'labstep-web/prosemirror/components/Toolbar/ProtocolValue';
import type React from 'react';
import styles from './styles.module.scss';
import type { IToolbarInlineProps } from './types';

export const ToolbarInline: React.FC<IToolbarInlineProps> = ({
  view,
  experimentWorkflow,
  entity,
}) => {
  let experiment: Experiment | null = null;
  let protocol: Protocol | null = null;
  if (entity instanceof Experiment) {
    experiment = entity;
  } else if (entity instanceof Protocol) {
    protocol = entity;
  }
  const { state, dispatch } = view;
  return (
    <Dropdown
      className={styles.dropdown}
      trigger={
        <ToolbarButton
          popup="Insert Elements"
          icon="plus circle"
          className={styles.dropdownIcon}
        />
      }
    >
      {experiment ? (
        <>
          {!experimentWorkflow && (
            <ToolbarProtocolStep
              state={state}
              dispatch={dispatch}
              protocol={experiment}
              isToolbarButton={false}
            />
          )}
          {experimentWorkflow && (
            <ToolbarExperiment
              view={view}
              experimentWorkflow={experimentWorkflow}
            />
          )}
          <ToolbarProtocolTable
            state={state}
            dispatch={dispatch}
            entity={experiment}
          />
          <ToolbarProtocolValue view={view} protocol={experiment} />
          <ToolbarMetadata
            state={state}
            dispatch={dispatch}
            entity={entity!}
          />
          {!experimentWorkflow && (
            <ToolbarProtocolTimer
              state={state}
              dispatch={dispatch}
              protocol={experiment}
            />
          )}
        </>
      ) : (
        <>
          <ToolbarProtocolStep
            state={state}
            dispatch={dispatch}
            protocol={protocol!}
            isToolbarButton={false}
          />
          <ToolbarProtocolTable
            state={state}
            dispatch={dispatch}
            entity={protocol!}
          />
          <ToolbarProtocolValue view={view} protocol={protocol!} />
          <ToolbarMetadata
            state={state}
            dispatch={dispatch}
            entity={entity!}
          />
          <ToolbarProtocolTimer
            state={state}
            dispatch={dispatch}
            protocol={protocol!}
          />
        </>
      )}
      <ToolbarFile
        key={1}
        state={state}
        dispatch={dispatch}
        entity={entity!}
      />
      <ToolbarFile
        key={2}
        state={state}
        dispatch={dispatch}
        entity={entity!}
        isImage
      />
      <ToolbarLink state={state} dispatch={dispatch} />
      <CodeToolbar state={state} dispatch={dispatch} />
    </Dropdown>
  );
};
